"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ng2_tooltip_component_1 = require("./ng2-tooltip-component");
exports.Ng2TooltipComponent = ng2_tooltip_component_1.Ng2TooltipComponent;
var ng2_tooltip_overlay_module_1 = require("./ng2-tooltip-overlay.module");
exports.Ng2TooltipOverlayModule = ng2_tooltip_overlay_module_1.Ng2TooltipOverlayModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-tooltip-overlay/dist/index.js
// module id = 91
// module chunks = 0